import SinglePolicyAnnuityView from "./SinglePolicyAnnuityView";
import SinglePolicyLifeTermView from "./SinglePolicyView";
import config from "config/config";
import { getTypeOfPolicy } from "js/utilities";

const SinglePolicyView = ({
  policy,
  policyDetail,
  filteredDocuments,
  deathBenefitValue,
}) => {
  const policyType = getTypeOfPolicy(policyDetail?.policy_detail?.productType);

  if (config.ENABLE_ANNUITIES === "true" && policyType === "annuity") {
    return (
      <SinglePolicyAnnuityView
        policy={policy}
        policyDetail={policyDetail}
        filteredDocuments={filteredDocuments}
        deathBenefitValue={deathBenefitValue}
      />
    );
  }

  return (
    <SinglePolicyLifeTermView
      policy={policy}
      policyDetail={policyDetail}
      filteredDocuments={filteredDocuments}
    />
  );
};

export default SinglePolicyView;
